import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import Loader from "./Loader";
import { useNavigate } from "react-router-dom";

const baseUrl = process.env.REACT_APP_API_BASE_URL;

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [filter] = useState("All");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalUsers, setTotalUsers] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const itemsPerPage = 10;
  const navigate = useNavigate();

  const fetchUsers = useCallback(async () => {
  setLoading(true);
  setError("");
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${baseUrl}/users/list?search=${search}&status=${filter}&page=${currentPage}&perPage=${itemsPerPage}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    const result = await response.json();
    if (result.status === true && Array.isArray(result.data)) {
      setUsers(result.data);
      setTotalUsers(result.pagination?.total || 0);
    } else {
      throw new Error(result?.message || "Failed to fetch user list");
    }
  } catch (err) {
    setError(err.message);
  }
  setLoading(false);
}, [search, filter, currentPage]);

  useEffect(() => {
  fetchUsers();
}, [fetchUsers]);


  

  const filteredData = users.filter((item) => {
    const fullName = `${item.firstName} ${item.lastName}`;
    return (
      (filter === "All" || item.status === filter) &&
      (fullName.toLowerCase().includes(search.toLowerCase()) ||
        item.email.toLowerCase().includes(search.toLowerCase()) ||
        item.username.toLowerCase().includes(search.toLowerCase()))
    );
  });

  const totalPages = Math.ceil(totalUsers / itemsPerPage);

  // Pagination logic for 5-page window
  const maxVisiblePages = 5;
  let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
  let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

  if (endPage - startPage < maxVisiblePages - 1) {
    startPage = Math.max(1, endPage - maxVisiblePages + 1);
  }

  return (
    <div className="flex bg-gray-50 min-h-screen">
      <Sidebar />
      <div className="flex-1 flex flex-col">
        <Navbar />
        <div className="p-8">
          <h4 className="text-2xl font-semibold mb-4 text-gray-800">Users</h4>
          {/* Search & Filter */}
          <div className="flex justify-between mb-6 bg-white border border-gray-200 p-4 rounded-lg shadow-sm">
            <span className="text-sm text-gray-600 mt-2">
              Showing {filteredData.length} of {totalUsers} users
            </span>
            <input
            className="px-4 py-2 bg-white border border-gray-300 text-gray-800 rounded-lg w-1/3 focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              type="text"
              placeholder="Search..."
              value={search}
              onChange={(e) => {
                setSearch(e.target.value);
                setCurrentPage(1); // Reset page to 1 on search
              }}
            />

            {/* <select
              value={filter}
              onChange={(e) => {
                setFilter(e.target.value);
                setCurrentPage(1); // Reset page to 1 on filter
              }}
            >
              <option value="All">All</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </select> */}
          </div>
          

          {/* Table */}
          {loading ? (
            <div className="p-6 text-center"><Loader text="Loading users..." /></div>
          ) : error ? (
            <p className="text-red-500">Error: {error}</p>
          ) : (
            <>
              <div className="overflow-hidden rounded-lg shadow-sm border border-gray-200">
                <table className="w-full bg-white rounded-lg">
                  <thead>
                    <tr className="bg-gray-50 text-gray-800 text-left border-b border-gray-200">
                      <th className="py-3 px-6 font-medium">Username</th>
                      <th className="py-3 px-6 font-medium">Email</th>
                      <th className="py-3 px-6 font-medium">Coin</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredData.map((user) => (
                      <tr
                        key={user.id}
                        className="border-b border-gray-100 hover:bg-gray-50 transition cursor-pointer"
                        onClick={() => navigate(`/user/${user.userId}`)}
                      >
                        <td className="py-4 px-6 text-gray-700">{user.username}</td>
                        <td className="py-4 px-6 text-gray-700">{user.email}</td>
                        <td className="py-4 px-6 text-blue-600 font-medium">{user.coin}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              <div className="flex justify-center mt-6 space-x-2 items-center">
                <button
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                  className="px-3 py-2 border border-gray-300 bg-white text-gray-700 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  &laquo;
                </button>

                {Array.from({ length: endPage - startPage + 1 }, (_, i) => {
                  const page = startPage + i;
                  return (
                    <button
                      key={page}
                      className={`px-4 py-2 border border-gray-300 rounded-md transition duration-300 ${
                        currentPage === page
                          ? "bg-blue-500 text-white border-blue-500"
                          : "bg-white text-gray-700 hover:bg-gray-50"
                      }`}
                      onClick={() => setCurrentPage(page)}
                    >
                      {page}
                    </button>
                  );
                })}

                <button
                  disabled={currentPage === totalPages}
                  onClick={() =>
                    setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                  }
                  className="px-3 py-2 border border-gray-300 bg-white text-gray-700 rounded-md hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  &raquo;
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default UserList;
